module.exports = __webpack_public_path__ + "images/db-logos/hive.png";